// extracted by mini-css-extract-plugin
export var cross = "Toggle-module--cross--cdb36";
export var hamburger = "Toggle-module--hamburger--afedd";
export var line = "Toggle-module--line--1497e";
export var toggle = "Toggle-module--toggle--1989d";